<template>
  <div class="tl">
    <Breadcrumbs main="Рейтинг MLBB" title="Рейтинг турниров MLBB"/>

    <div class="container-fluid tl-container">
      <div class="tl-panel">
        <div v-if="loading" class="tl-skeleton">
          <div v-for="n in 8" :key="'sk' + n" class="tl-skeleton__row">
            <span class="tl-sk tl-sk--sm"></span>
            <span class="tl-sk tl-sk--wide"></span>
            <span class="tl-sk"></span>
            <span class="tl-sk tl-sk--sm"></span>
          </div>
        </div>

        <div v-else-if="!tournaments.length" class="tl-empty">
          <div class="tl-empty__art"><i class="fa fa-trophy"></i></div>
          <div class="tl-empty__title">Турниров нет</div>
          <div class="tl-empty__text">Здесь появятся турниры MLBB с рейтингом команд.</div>
        </div>

        <div v-else class="tl-table-wrap">
          <b-table class="tl-table rt-table"
                   responsive
                   hover
                   borderless
                   :items="tournaments"
                   :fields="fields"
                   @row-clicked="openRatings">
            <template #cell(id)="{ item }">
              <button type="button" class="tl-id" @click.stop="copyId(item.id)"
                      v-b-tooltip.hover.right="'Скопировать ID турнира'">
                <span>#{{ item.id }}</span>
                <i class="fa fa-copy"></i>
              </button>
            </template>

            <template #cell(name)="{ item }">
              <router-link class="rt-team__name"
                           :to="{ name: 'rating_mlbb_tournaments_info', params: { id: item.id } }"
                           @click.native.stop>{{ item.name }}</router-link>
            </template>

            <template #cell(end_time)="{ item }">
              <span :class="{ 'rt-dim': !item.end_time }">{{ formatEndTime(item.end_time) }}</span>
            </template>

            <template #cell(action)="{ item }">
              <router-link class="tl-icon-btn rt-open"
                           :to="{ name: 'rating_mlbb_tournaments_info', params: { id: item.id } }"
                           @click.native.stop
                           v-b-tooltip.hover.left="'Рейтинг команд турнира'">
                <i class="fa fa-angle-right"></i>
              </router-link>
            </template>
          </b-table>
        </div>

        <div v-if="!loading && tournaments.length" class="tl-foot">
          <div class="tl-foot__info">
            Показано <b>{{ tournaments.length }}</b> из <b>{{ pagination.total || 0 }}</b>
          </div>
          <b-pagination class="tl-pagination my-0"
                        v-model="currentPage"
                        :total-rows="pagination.total"
                        :per-page="pagination.by || 10"
                        :limit="7"
                        @change="onPageChange"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/api.js'

export default {
  name: "TournamentMlbb",
  data() {
    return {
      // Список турниров
      tournaments: [],
      // Объект пагинации
      pagination: {},
      // Поля таблицы
      fields: [
        { key: 'id', label: 'ID', sortable: true, thClass: 'tl-th--id' },
        { key: 'name', label: 'Турнир', sortable: true },
        { key: 'end_time', label: 'Завершён', sortable: true },
        { key: 'action', label: '', sortable: false, thClass: 'tl-th--act', tdClass: 'tl-td--act' },
      ],
      // Текущая страница пагинации
      currentPage: 1,
      // Флаг загрузки
      loading: false
    }
  },
  created() {
    // Считываем page из query, если есть
    const pageFromQuery = parseInt(this.$route.query.page, 10)
    if (!isNaN(pageFromQuery) && pageFromQuery > 0) {
      this.currentPage = pageFromQuery
    }

    // Загружаем данные при инициализации компонента
    this.loadData()
  },
  watch: {
    // Следим за изменением query‐параметра "page" в маршруте
    '$route.query.page'(newVal) {
      const pageNumber = parseInt(newVal, 10)
      if (!isNaN(pageNumber) && pageNumber !== this.currentPage) {
        this.currentPage = pageNumber
        this.loadData()
      }
    }
  },
  methods: {
    async loadData() {
      // Устанавливаем флаг загрузки
      this.loading = true

      try {
        const response = await api.tournament.index({
          'filter[game_id]': 3,
          page: this.currentPage
        })

        this.tournaments = response.data?.tournaments || []
        this.pagination = response.data?.pagination || {}
      } catch (error) {
        console.error('Ошибка при получении данных:', error)
      } finally {
        // Сбрасываем флаг загрузки
        this.loading = false
      }
    },

    formatEndTime(endTime) {
      if (!endTime) return '—'
      const date = new Date(endTime)
      if (isNaN(date.getTime())) return '—'
      const pad = (n) => String(n).padStart(2, '0')
      return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`
    },

    openRatings(item) {
      this.$router.push({ name: 'rating_mlbb_tournaments_info', params: { id: item.id } })
    },

    copyId(id) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(String(id)).then(() => {
          this.$toasted.success('ID турнира скопирован', { position: 'top-right', duration: 1500 })
        }).catch(() => {
        })
      }
    },

    // При смене страницы пользователь кликает на пагинацию
    onPageChange(page) {
      // Обновляем query-параметры (обновление URL при переключении страницы)
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          page
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/admin-list.scss";
@import "~@/assets/scss/rating-list.scss";

.tl { @include rating-list-parts; }
</style>
